<ion-button type="button" fill="clear" class="studentItem" (click)="studentClicked($event)">
  <div class="studentItemInnerCont">
    <span class="studentAvatar">
      <span class="initials">
        {{ student.forename[0] + student.surname[0] }}
      </span>
    </span>

    <span class="separator"></span>

    <span class="studentName">{{ student.forename }}</span>
    <!-- <span class="studentYear">{{student.form}}</span> -->

    @if (showAttendance && student.lastSession) {
      <div class="attendanceCont">
        <span
          class="studentAttendanceAM"
        [ngClass]="student.lastSession !== null ? student.lastSession.am.class : 'none'"></span>
        <span
          class="studentAttendancePM"
        [ngClass]="student.lastSession !== null ? student.lastSession.pm.class : 'none'"></span>
      </div>
    }
  </div>
</ion-button>
